import { render } from "./HeaderKiosk.vue?vue&type=template&id=77825ec8"
import script from "./HeaderKiosk.vue?vue&type=script&lang=js"
export * from "./HeaderKiosk.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__